import { render, staticRenderFns } from "./PseudoBreadcrumbs.vue?vue&type=template&id=032c91a4&scoped=true&"
import script from "./PseudoBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./PseudoBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./PseudoBreadcrumbs.vue?vue&type=style&index=0&id=032c91a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c91a4",
  null
  
)

export default component.exports